
import { AccountController } from "@/app/ui/controllers/AccountController";
import { Vue, Options, prop } from "vue-class-component";
import { ShipmentBookingDetail } from "@/domain/entities/ShipmentBooking";
import { formatByCountry } from "@/app/infrastructures/misc/Utils";
import downloadFile from "@/app/infrastructures/misc/common-library/DownloadFile";

class Props {
  detailData = prop<ShipmentBookingDetail>({
    required: true
  });
  photos = prop<string[]>({
    required: true,
    default: () => []
  });
  sttCipl = prop<string[]>({
    required: true,
    default: () => []
  });
  isShowInfoDetail = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({})
export default class DetailFtzSection extends Vue.with(Props) {
  get accountCurrency(): "IDR" | "MYR" {
    return (
      (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ?? "IDR"
    );
  }

  formatPrice(val: number) {
    return formatByCountry(val, {
      type: "money",
      prefix: this.accountCurrency === "MYR" ? "RM" : "Rp"
    });
  }

  formatQuantity(val: number) {
    return formatByCountry(val, { type: "quantity" });
  }

  photoPreview = false;
  photo = "";
  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }

  onPreview(photo: string) {
    this.photo = photo;
    this.photoPreview = true;
  }

  isPdfDocument(url: string): boolean {
    return this.getFileType(url) === "pdf";
  }

  getFileType(url: string): string {
    const urlParts = url.split(".");
    return urlParts[urlParts.length - 1].toLowerCase();
  }

  getPdfDisplayName(url: string): string {
    const fileName = url.split("/").pop() || "document.pdf";
    return fileName.replace(/\.pdf$/i, "");
  }

  downloadPdf(url: string) {
    return downloadFile(url, this.getPdfDisplayName(url), ".pdf");
  }

  get photoPreviews() {
    return this.photos.map((item: any) => {
      return {
        image: item,
        url: item
      };
    });
  }
}
